import * as prismic from '@prismicio/client';

export const client = prismic.createClient(window.config.PRISMIC_REPOSITORY_NAME);
